import gsap from "gsap";
export const makeOptimisticComment = ({
	id = `temp-${Date.now()}`,
	html,
	content,
	user,
	threadId = null,
	parentCommentId = null,
	mentions = [],
	attachments = [],
}) => ({
	id,
	mentions,
	attachments,
	threadId,
	parentCommentId,
	user,
	content: content ?? html,
	isPending: true,
	isFailed: false,
});


export const getFormattedDate = (dateString) => {
	const createdAt = new Date(dateString);
	const options = {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
	};
	return createdAt.toLocaleString("en-US", options).replace(" at", ", ");
};

export const getFormattedTime = (dateString) => {
	const d = getFormattedDate(dateString);
	return d.split(", ").at(-1);
};

export const getFormattedDay = (dateString) => {
	const d = new Date(dateString);
	return d.toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});
};

export const highlightElement = (el, duration = 2) => {
	if (!el) return;
	el.classList.add("highlight");

	gsap.to(el, {
		duration: duration,
		delay: 0.2,
		onStart: () => {
			el.style.transitionDuration = duration + "s";
			el.classList.remove("highlight");
		},
		onComplete: () => {
			gsap.set(el, { clearProps: "transitionDuration" });
		},
	})
}

export const generateThreadUrl = (thread) => {
	if (!thread.url)
		return 'N/A';
	
	const url = new URL(thread.url);
	url.searchParams.set('thread', thread.id);
	return url.toString();
}

export function timeAgo(dateString) {
	const date = new Date(dateString);
	const now = new Date();
	const diffMs = now - date;
	const diffSec = Math.floor(diffMs / 1000);
	const diffMin = Math.floor(diffSec / 60);
	const diffHour = Math.floor(diffMin / 60);
	const diffDay = Math.floor(diffHour / 24);
	const diffWeek = Math.floor(diffDay / 7);
	const diffMonth = Math.floor(diffDay / 30);
	const diffYear = Math.floor(diffDay / 365);

	if (diffMin < 1) return 'just now';
	if (diffHour < 1) return `${diffMin} min${diffMin === 1 ? '' : 's'} ago`;
	if (diffDay < 1) return `${diffHour} hour${diffHour === 1 ? '' : 's'} ago`;
	if (diffWeek < 1) return `${diffDay} day${diffDay === 1 ? '' : 's'} ago`;
	if (diffMonth < 1) return `${diffWeek} week${diffWeek === 1 ? '' : 's'} ago`;
	if (diffYear < 1) return `${diffMonth} month${diffMonth === 1 ? '' : 's'} ago`;
	return `${diffYear} year${diffYear === 1 ? '' : 's'} ago`;
}